/**
 * パレットの候補（お気に入り・履歴）をまとめて用意する
 * DB は遅いので、パレットでは検索せず DB タブで検索する
 */

import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { getMealItemHistory } from '@/api/services/nutrition'
import type { FoodTemplate } from '@/api/types/nutrition'
import { useDebouncedValue } from '@/hooks/useDebouncedValue'

import { pickPaletteTemplates } from './palette-utils'

const EMPTY_TEMPLATE_LIMIT = 4
const EMPTY_HISTORY_LIMIT = 6
const QUERY_LIMIT = 5

export function useFoodPalette(templates: FoodTemplate[], query: string) {
  const trimmed = query.trim()
  const debounced = useDebouncedValue(trimmed)
  const isEmpty = trimmed.length === 0

  const favorites = useMemo(
    () => pickPaletteTemplates(templates, trimmed, isEmpty ? EMPTY_TEMPLATE_LIMIT : QUERY_LIMIT),
    [templates, trimmed, isEmpty],
  )

  const historyLimit = debounced ? QUERY_LIMIT : EMPTY_HISTORY_LIMIT
  const history = useQuery({
    queryKey: ['nutrition', 'meal-item-history', 'palette', debounced, historyLimit],
    queryFn: () => getMealItemHistory(debounced, historyLimit, 0),
    // 記録したばかりの食品がすぐ出るよう、開くたびに取り直す
    staleTime: 0,
  })

  return {
    isEmpty,
    favorites,
    history: history.data?.items ?? [],
    historyLoading: history.isLoading,
    canSearchDb: trimmed.length >= 2,
  }
}
